import { PopupModal } from "./popup.modal";
import {
  useAppDispatch,
  useAppSelector,
  useQuery,
} from "features/config/hooks";

import { useNavigate } from "react-router-dom";
import {
  getStockOrderSettingProducts,
  selectGetStockOrderSettingProducts,
} from "../slices/stock-order-get-settings-products.slice";
import { FaBox, FaKey, FaWarehouse, FaWeight } from "react-icons/fa";
import { MaterialInput } from "features/shared/presentation/components";
import { ChangeEvent, useRef, useState } from "react";
import { updateNewProductStock } from "../slices/update-new-product-stock.slice";
import {
  closeMessageModal,
  openMessageModal,
} from "features/shared/presentation/slices/message-modal.slice";

interface UpdateStockProps {
  open: boolean;
  onClose: (value: boolean) => void;
}

export function UpdateStock(props: UpdateStockProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const category = [
    { id: 1, name: "Frozen" },
    { id: 2, name: "Dry" },
  ];

  const query = useQuery();

  const prodId = query.get("productId");

  const getStockOrderSettingsProductsState = useAppSelector(
    selectGetStockOrderSettingProducts
  );

  const [stock, setStock] = useState(0);

  const { product_id, product_name, current_stock, uom, category_id } =
    getStockOrderSettingsProductsState.data?.products.find(
      (product) => product.product_id === prodId
    ) ?? {};

  const resetModal = () => {
    navigate({ pathname: "" });
    props.onClose(false);
  };

  const handleUpdateStock = () => {
    dispatch(
      openMessageModal({
        message:
          "Are you sure you want to update the stock? This action cannot be undone.",
        buttons: [
          {
            text: "Yes",
            color: "#cc5801 ",
            onClick: () => {
              dispatch(
                updateNewProductStock({
                  newStock: stock,
                  productId: product_id,
                })
              );

              resetModal();
              dispatch(closeMessageModal());
            },
          },
          {
            text: "Cancel",
            color: "#22201A",
            onClick: () => {
              dispatch(closeMessageModal());
            },
          },
        ],
      })
    );
  };

  const handleInputChange = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setStock(Number(e.target.value));
  };

  return (
    <PopupModal
      noIcon
      open={props.open}
      title={"Update stock"}
      message={""}
      customButton
      onClose={resetModal}
      customModalWidth="md:w-[50%] lg:w-[460px]"
      backgroundColor="bg-gray-200"
    >
      <div className="flex flex-col space-y-2">
        <div className="flex flex-col text-xs font-[Roboto] py-0.5 space-y-1">
          <p className="font-semibold text-xl">{product_name}</p>

          <div className="flex space-x-3 w-full">
            <div className="flex space-x-1">
              <FaKey className="self-center text-button text-[10px]" />

              <p>{product_id}</p>
            </div>

            <div className="flex justify-evenly w-full">
              <div className="flex space-x-1">
                <FaWeight className="self-center text-button text-[10px]" />
                <span className="text-xs whitespace-nowrap">Uom:</span>

                <p>{uom}</p>
              </div>

              <div className="flex space-x-1">
                <FaBox className="self-center text-button text-[10px]" />
                <span className="text-xs whitespace-nowrap">
                  Category Type:
                </span>

                <p>
                  {
                    category.find(
                      (category) => category.id === Number(category_id)
                    )?.name
                  }
                </p>
              </div>

              <div className="flex space-x-1">
                <FaWarehouse className="self-center text-button text-[10px]" />
                <span className="text-xs whitespace-nowrap">
                  Current Stock:
                </span>
                <p>{current_stock}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <span className="text-xs text-gray-500">
            Input the updated number of items currently in stock. Only whole
            numbers are allowed.
          </span>
          <MaterialInput
            id="stock-input"
            name="stock-input"
            size="small"
            colorTheme="black"
            placeholder="e.g. 100"
            onChange={handleInputChange}
          />

          <button
            onClick={handleUpdateStock}
            className="bg-button text-white rounded-md py-1"
          >
            Update
          </button>
        </div>
      </div>
    </PopupModal>
  );
}
